import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuItemPath, MenuItem } from '@enums/menu-item.enum';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { UsersComponent } from './pages/users/users.component';

const routes: Routes = [
    {
      path: MenuItemPath.get(MenuItem.users),
      component: UsersComponent,
      canActivate: [AuthGuard]
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
})

export class UsersRoutingModule { }
